export default values => ({
  ...values,
  clientName: values.clientName || '',
  equipmentId: values.equipmentId || '',
  clientId: values.clientId || '',
  clientPersonType: values.clientPersonType || '',
  sendToDigitalSign: false,
  avals: values.avals || []
});
